import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=e00c7650&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00c7650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e00c7650')) {
      api.createRecord('e00c7650', component.options)
    } else {
      api.reload('e00c7650', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=e00c7650&scoped=true&", function () {
      api.rerender('e00c7650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Payment.vue"
export default component.exports